import { useEffect, useState } from 'react';
import { Link, NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { api } from '../api/client';

const linkStyle: React.CSSProperties = {
  color: 'var(--ha-text-muted)', textDecoration: 'none', fontSize: '0.875rem',
};
const activeLinkStyle: React.CSSProperties = { ...linkStyle, color: 'var(--ha-text-primary)' };

export function Layout() {
  const { user, isAdmin, logout } = useAuth();
  const navigate = useNavigate();
  const [version, setVersion] = useState<string>('');

  useEffect(() => {
    api.get<{ version: string }>('/api/meta')
      .then((m) => setVersion(m.version))
      .catch(() => setVersion(''));
  }, []);

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <nav style={{
        background: 'var(--ha-bg-surface)', borderBottom: '1px solid var(--ha-border)',
        padding: '0.75rem 1.5rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      }}>
        <Link to="/" style={{ color: 'var(--ha-text-primary)', textDecoration: 'none', fontWeight: 600, letterSpacing: '0.01em' }}>
          Codenteam Hub
        </Link>
        <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
          {user ? (
            <>
              <NavLink to="/dashboard" style={({ isActive }) => (isActive ? activeLinkStyle : linkStyle)}>
                {user.username}
              </NavLink>
              {isAdmin && (
                <>
                  <NavLink to="/admin" end style={({ isActive }) => (isActive ? activeLinkStyle : linkStyle)}>Admin</NavLink>
                  <NavLink to="/admin/docker" style={({ isActive }) => (isActive ? activeLinkStyle : linkStyle)}>Docker</NavLink>
                  <NavLink to="/admin/caddy" style={({ isActive }) => (isActive ? activeLinkStyle : linkStyle)}>Caddy</NavLink>
                  <NavLink to="/admin/services" style={({ isActive }) => (isActive ? activeLinkStyle : linkStyle)}>Services</NavLink>
                  <NavLink to="/admin/security" style={({ isActive }) => (isActive ? activeLinkStyle : linkStyle)}>Security</NavLink>
                </>
              )}
              <NavLink to="/account" style={({ isActive }) => (isActive ? activeLinkStyle : linkStyle)}>Account</NavLink>
              <button
                type="button"
                className="btn-ghost"
                style={{ padding: '0.25rem 0.75rem', fontSize: '0.875rem' }}
                onClick={() => { void logout().then(() => navigate('/login')); }}
              >
                Logout
              </button>
            </>
          ) : (
            <>
              <Link to="/login" className="btn-ghost" style={{ padding: '0.25rem 0.75rem', fontSize: '0.875rem' }}>Login</Link>
              <Link to="/register" className="btn-primary" style={{ padding: '0.25rem 0.75rem', fontSize: '0.875rem' }}>Sign up</Link>
            </>
          )}
        </div>
      </nav>

      <main style={{ maxWidth: 1200, width: '100%', margin: '0 auto', padding: '2rem 1.5rem', flex: 1 }}>
        <Outlet />
      </main>

      <footer style={{ borderTop: '1px solid var(--ha-border)', padding: '0.75rem 1.5rem', textAlign: 'center' }}>
        <span className="mono" style={{ color: 'var(--ha-text-disabled)', fontSize: '0.75rem' }}>
          Codenteam Hub{version ? ` v${version}` : ''}
        </span>
      </footer>
    </div>
  );
}
